import { combineReducers } from 'redux';
import list from './list';
import save from './save';
import del from './delete';
import show from './show';

export default combineReducers({ list, save, del, show});
